<template lang="pug">
vm-row(vm-w="12")
  vm-col.card(vm-sm=12)
    vm-table(multiple v-model="selected"  max-height="350px" :data="purchaseOrders" )
      template(slot="header")
        .d-flex.justify-content-between
          vm-input(ref="search" icon="search" size="small" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="200px")
          div
            vm-button(class="btn-requisitions" @click="deleteRecords" :disabled="!enabledDelete")
              vm-icon(icon="trash-2-outline")
            vm-tooltip(:text="$t('strings.filters')" delay=".5s")
              vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="default" icon="funnel-outline" size="small")
                vm-dropdown-menu(class="filters")
                  .heading.d-flex.justify-content-between
                    h4 {{ $t('strings.filters') }}
                    vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                  vm-date-picker.filter(type="daterange" :label="$t('requisitions_mailboxes.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                  .filter.d-flex
                    vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
            vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('requisitions_mailboxes.'+ item)")
              vm-order-by-item(value='folio,asc' text='Folio' direction='down')
              vm-order-by-item(value='folio,desc' text='Folio' direction='up')
              vm-order-by-item(value='created_at,asc' text='Creado el' direction='down')
              vm-order-by-item(value='created_at,desc' text='Creado el' direction='up')
            vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
              vm-button(type="default" size="small" icon="list" style="display: none;")
            vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
              vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
      template(slot="thead")
          vm-th(:key="index" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
            .details(@click="detailsPurchase(data[indextr])")
              slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
              vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{ $t('purchase_orders.'+ data[indextr]['status']) }}
        template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
              .details(@click="detailsPurchase(data[indextr])")
                slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{ $t('purchase_orders.'+ data[indextr]['status']) }}
            vm-td
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == 'Inactivo'" @click="setActionRecord(data[indextr], 'actived')")
                  vm-icon(icon="person-done-outline")
                  slot &nbsp;{{ $t('strings.action_active') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                //- More actions
    vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
    transition(name="enter")
      .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalPurchaseOrders = () => import('@/components/modals/ModalPurchaseOrders.vue')

export default {
  name: 'PurcharseOrdersView',
  components: {
    ModalImport,
    ModalPurchaseOrders
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: [
      'id',
      'folio',
      'project_display',
      'supplier_display',
      'email',
      'shipping_address',
      'delivery_time',
      'deadline',
      'freight',
      'notes',
      'status',
      'user_display',
      'created_at'
    ],
    columnsOrderBy: ['folio', 'created_at'],
    attributeModal: 'folio',
    status: [
      {
        value: 'pending',
        color: 'primary'
      },
      {
        value: 'sended',
        color: 'success'
      },
      {
        value: 'completed',
        color: 'success'
      },
      {
        value: 'cancelled',
        color: 'danger'
      },
      {
        value: 'partially_stocked',
        color: 'warning'
      },
      {
        value: 'approved',
        color: 'success'
      },
      {
        value: 'authorized',
        color: 'success'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        folio: '',
        email: '',
        supplier: {
          name: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['purchaseOrders', 'catalog', 'pagination', 'filterParams'])
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'setModalSummaryVisible'
    ]),
    detailsPurchase (record) {
      this.$emit('odDetails', record)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
